
import { Component, Prop, Vue } from 'vue-property-decorator'
import PackageDescriptionItems from '~/components/common/modals/payment/PackageDescriptionItems.vue'

@Component({
  components: {
    PackageDescriptionItems
  }
})
export default class Package extends Vue {
  @Prop({ type: Number, required: true }) packageId!: number
  @Prop({ type: String, default: '' }) name!: string
  @Prop({ type: Number, required: true }) price!: number
  @Prop({ type: Number, required: true }) pricePerMonth!: number
  @Prop({ type: String, required: true }) discountPrice!: number
  @Prop({ type: String, default: '' }) recurrentPriceMessage!: string
  @Prop({ type: String, default: '' }) billingAgreement!: string
  @Prop({ type: String, required: true }) expirationType!: string
  @Prop({ type: String, default: '' }) expirationPeriodType!: string
  @Prop({ type: Number, required: true }) expirationPeriodValue!: number
  @Prop({ type: String, default: '' }) paypalExpirationType!: string
  @Prop({ type: Boolean, default: false }) contactUsLink!: boolean
  @Prop({ type: String, default: '' }) buttonText!: string
  @Prop({ type: String, default: '' }) buttonCSS!: string
  @Prop({ type: String, default: '' }) displayMessage!: string
  @Prop({ type: Array, default: '' }) displayDescriptionItems!: string[]
  @Prop({ type: String, default: '' }) displaySuccessMessage!: string
  @Prop({ type: Boolean, default: false }) isMarked!: boolean
  @Prop({ type: Boolean, default: false }) isContactUs!: boolean
  @Prop({ type: Boolean, default: false }) isFreemium!: boolean
  @Prop({ type: Boolean, default: false }) isFreeTrial!: boolean

  get isFree() {
    return this.price === 0
  }

  get isRecurrent() {
    return this.expirationType === 'recurrent' && this.pricePerMonth
  }

  get hasDiscount() {
    return Number(this.discountPrice) !== 0
  }

  get finalPrice() {
    return this.isFree
      ? 'FREE'
      : this.hasDiscount
        ? this.discountPrice
        : this.isRecurrent
          ? this.pricePerMonth
          : this.price
  }

  get button() {
    return this.buttonText
      ? this.buttonText
      : this.isFree
        ? 'Continue'
        : 'Upgrade'
  }
}
